"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _logoWithoutLink = _interopRequireDefault(require("../logo-without-link"));

// Logo
// ====
var Logo = function Logo(_ref) {
  var url = _ref.url,
      className = _ref.className,
      linkClassName = _ref.linkClassName,
      type = _ref.type;

  if (url) {
    return _react["default"].createElement("a", {
      className: linkClassName,
      href: url
    }, _react["default"].createElement(_logoWithoutLink["default"], {
      className: className,
      type: type
    }));
  } else {
    return _react["default"].createElement(_logoWithoutLink["default"], {
      className: className,
      type: type
    });
  }
};

Logo.defaultProps = {
  type: 'default'
};
Logo.propTypes = {
  url: _propTypes["default"].string,
  className: _propTypes["default"].string,
  linkClassName: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['default', 'alt', 'direct'])
};
var _default = Logo;
exports["default"] = _default;